module.exports = __webpack_public_path__ + "static/FAQ-share2-073422fbd335c947b2455e38b4222d06.jpg";